import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import DataParser from "../../../utlits/Dataparser";
import Sidebar from "../../Layouts/Sidebar";
import CommunicationsServices from "../../../Services/CommunicationsServices";
import secureLocalStorage from "react-secure-storage";

const Communication = () => {
  const [CommunicationList, setCommunicationList] = useState([]);
  const [userPermissions, setuserPermissions] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [communicationName, setCommunicationName] = useState("");
  const [communicationEditName, setCommunicationEditName] = useState("");
  const [editValue, setEditValue] = useState(null);

  const companyId = DataParser.CompanyId();
  const navigate = useNavigate();

  const getData = () => {
    setLoading(true);
    CommunicationsServices.getCommunicationsServices(companyId).then((res) => {
      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
      }
      const data = res.data.communications;
      setCommunicationList(data);
      setLoading(false);
    });
  };

  useEffect(() => {
    getData();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  const handelSubmit = (e) => {
    e.preventDefault();
    const AddPackageData = {
      name: communicationName,
      company_id: companyId,
    };
    CommunicationsServices.createCommunications(AddPackageData)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
        }
        if (res.Good === true) {
          var link = document.getElementById("CommunicationModalCreate");
          link.click();
          setCommunicationName("");
          getData();
        }
      })
      .catch((err) => {});
  };

  const handleOpenUpadte = (e, item) => {
    setCommunicationEditName(item.value);
    setEditValue(item);
  };

  const handelEditSubmit = (e) => {
    e.preventDefault();
    const id = editValue.id;
    try {
      const AddData = {
        name: communicationEditName,
      };
      CommunicationsServices.editCommunication(id, AddData)
        .then((res) => {
          if (res.data === "Un-Athunticated request") {
            secureLocalStorage.removeItem("adminInfo");
            secureLocalStorage.removeItem("admins");
            navigate("/");
          }
          if (res.Good === true) {
            var link = document.getElementById("CommunicationModalEdit");
            link.click();
            setCommunicationName("");
            getData();
          }
        })
        .catch((err) => {});
    } catch (err) {}
  };
  const handelDelete = (e, item) => {
    e.preventDefault();
    const id = item.id;
    const dataset = CommunicationList.filter((elsss) => elsss.id !== id);
    setCommunicationList(dataset);
    const companyId = DataParser.CompanyId();
    CommunicationsServices.deleteCommunicationsServices(id, companyId)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
        }
        getData();
      })
      .catch((err) => {});
  };

  return (
    <>
      <Helmet>
        <title>Communication - Planit</title>
      </Helmet>
      {/* <Sidebar /> */}
      <div className="main-content">
        <div className="page-content Pagebody">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0">All Communication Resource</h4>
                  <div className="page-title-right">
                  <ol
                      className="breadcrumb"
                      style={{ marginBottom: "10px !important" }}
                    >
                      <li className="breadcrumb-item">
                        <Link
                          to={`/${DataParser.CompanyIdentifierRole()}/home`}
                        >
                          Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">
                        {" "}
                        <Link
                          to={`/${DataParser.CompanyIdentifierRole()}/adminsettings`}
                        >
                          Settings
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Communication</li>
                    </ol>
                    <button
                    style={{ float: "right" }}
                      type="button"
                      className="btn btn-primary waves-effect waves-light"
                      data-bs-toggle="modal"
                      data-bs-target="#createCommunicationyModal"
                    >
                      Create Communication Resource
                    </button>
                    {/* Create modal content */}
                    <div
                      id="createCommunicationyModal"
                      className="modal fade"
                      tabIndex={-1}
                      role="dialog"
                      aria-labelledby="myModalLabel"
                      aria-hidden="true"
                    >
                      <form onSubmit={(e) => handelSubmit(e)}>
                        <div className="modal-dialog modal-dialog-centered">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="myModalLabel">
                                Create Communication
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                id="CommunicationModalCreate"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              />
                            </div>
                            <div className="modal-body">
                              <div className="row">
                                <div
                                  className="col-12 mb-3 d-flex"
                                  style={{ alignItems: "center" }}
                                >
                                  <div className="col-md-3">
                                    <label
                                      className="form-label"
                                      style={{
                                        paddingRight: 20,
                                        paddingBottom: 0,
                                        marginBottom: 0,
                                      }}
                                      htmlFor="Name"
                                    >
                                      Name
                                    </label>
                                  </div>
                                  <div className="col-md-9">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="Name"
                                      placeholder="Name"
                                      required
                                      value={communicationName}
                                      onChange={(e) =>
                                        setCommunicationName(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-light waves-effect"
                                data-bs-dismiss="modal"
                              >
                                Close
                              </button>
                              <button
                                onClick={(e) => handelSubmit(e)}
                                type="button"
                                className="btn btn-primary waves-effect waves-light"
                              >
                                Save changes
                              </button>
                            </div>
                          </div>
                          {/* /.modal-content modal-dialog-centere */}
                        </div>
                      </form>
                      {/* /.modal-dialog */}
                    </div>
                    {/* /.modal */}
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table mb-0 table-striped">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Communication Resource</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <>
                              <tr>
                                <td>
                                  <Skeleton width="40%" />
                                </td>
                                <td>
                                  <Skeleton width="40%" />
                                </td>
                                <td>
                                  <Skeleton width="40%" />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <Skeleton width="40%" />
                                </td>
                                <td>
                                  <Skeleton width="40%" />
                                </td>
                                <td>
                                  <Skeleton width="40%" />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <Skeleton width="40%" />
                                </td>
                                <td>
                                  <Skeleton width="40%" />
                                </td>
                                <td>
                                  <Skeleton width="40%" />
                                </td>
                              </tr>
                            </>
                          ) : (
                            <>
                              {CommunicationList &&
                                CommunicationList.map((item, index) => (
                                  <tr key={item.id}>
                                    <th scope="row">{index + 1}</th>
                                    <td className="tableset">{item.value}</td>
                                    <td className="tableset">
                                      {userPermissions.indexOf(
                                        "communication-delete"
                                      ) !== -1 ? (
                                        <Link
                                          to="#"
                                          className="cursor-pointer iconscolor"
                                          onClick={(e) => handelDelete(e, item)}
                                        >
                                          <i className="uil-trash iconscolor" />
                                        </Link>
                                      ) : (
                                        ""
                                      )}
                                      {userPermissions.indexOf(
                                        "communication-edit"
                                      ) !== -1 ? (
                                        <Link
                                          to="#"
                                          className="cursor-pointer iconscolor"
                                        >
                                          <i
                                            className="uil-pen iconscolor"
                                            onClick={(e) =>
                                              handleOpenUpadte(e, item)
                                            }
                                            data-bs-toggle="modal"
                                            data-bs-target="#editCategoryModal"
                                          />
                                        </Link>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                  </tr>
                                ))}
                            </>
                          )}
                          <div
                            id="editCategoryModal"
                            className="modal fade"
                            tabIndex={-1}
                            role="dialog"
                            aria-labelledby="myModalLabel"
                            aria-hidden="true"
                          >
                            <form onSubmit={(e) => handelEditSubmit(e)}>
                              <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5
                                      className="modal-title"
                                      id="myModalLabel"
                                    >
                                      Edit Communication Resource
                                    </h5>
                                    <button
                                      type="button"
                                      className="btn-close"
                                      id="CommunicationModalEdit"
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                    />
                                  </div>
                                  <div className="modal-body">
                                    <div className="row">
                                      <div
                                        className="col-12 mb-3 d-flex"
                                        style={{ alignItems: "center" }}
                                      >
                                        <div className="col-md-3">
                                          <label
                                            className="form-label"
                                            style={{
                                              paddingRight: 20,
                                              paddingBottom: 0,
                                              marginBottom: 0,
                                            }}
                                            htmlFor="Name"
                                          >
                                            Name
                                          </label>
                                        </div>
                                        <div className="col-md-9">
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="Name"
                                            placeholder="Name"
                                            required
                                            value={communicationEditName}
                                            onChange={(e) =>
                                              setCommunicationEditName(
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      className="btn btn-light waves-effect"
                                      data-bs-dismiss="modal"
                                    >
                                      Close
                                    </button>
                                    <button
                                      onClick={(e) => handelEditSubmit(e)}
                                      type="button"
                                      className="btn btn-primary waves-effect waves-light"
                                    >
                                      Save changes
                                    </button>
                                  </div>
                                </div>
                                {/* /.modal-content modal-dialog-centere */}
                              </div>
                            </form>
                            {/* /.modal-dialog */}
                          </div>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Communication;
